var scope_0 = require('/opt/buildhome/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/1f32a047e6335679a8e842155fe89f4c.js').default;
var scope_1 = require('/opt/buildhome/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/2f192dff44ca5334429f25fca6ebbf35.js').default;
var scope_2 = require('/opt/buildhome/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2 )
    